const BlogDetails = () => {
  return (
    <>
      {/* CATEGORY NAV */}
      <section className="bg-light">
        <div className="container">
          <ul className="nav blog-nav mb-4">
            <li className="nav-item">
              <button className="nav-link active">HPC</button>
            </li>
            <li className="nav-item">
              <button className="nav-link">Data Center</button>
            </li>
            <li className="nav-item">
              <button className="nav-link">Enterprise Network</button>
            </li>
            <li className="nav-item">
              <button className="nav-link">Cabling</button>
            </li>
            <li className="nav-item">
              <button className="nav-link">Newsroom</button>
            </li>
          </ul>
        </div>
      </section>

      <div className="container py-4">
        {/* BREADCRUMB */}
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb small mb-4">
            <li className="breadcrumb-item">
              <a href="#">Home</a>
            </li>
            <li className="breadcrumb-item">
              <a href="#">Software</a>
            </li>
            <li className="breadcrumb-item active">
              Simplified InfiniBand Network Management With NX Optics
            </li>
          </ol>
        </nav>

        <div className="row g-5">
          {/* LEFT CONTENT */}
          <div className="col-lg-8">
            <h1 className="blog-title mb-2">
              Simplified InfiniBand Network Management With NX Optics
            </h1>

            <div className="blog-meta d-flex align-items-center mb-3">
              <span>Howard</span>
              <span>Sep 28, 2024</span>
              <span>6 min read</span>
            </div>

            <div className="blog-share d-flex gap-3 mb-4">
              <a href="#">LinkedIn</a>
              <a href="#">Facebook</a>
              <a href="#">X</a>
              <a href="#">Copy Link</a>
            </div>

            <div className="blog-content">
              <p>
                High-performance computing (HPC) networks utilize powerful
                processor clusters to parallelly process massive,
                multidimensional datasets.
              </p>

              <p>
                With numerous nodes, HPC networks must be easily maintainable
                and manageable.
              </p>

              <h2>The Essential Role of Automated Network Deployment</h2>

              {Array(10).fill(0).map((_, i) => (
                <p key={i}>
                  HPC data centers typically consist of numerous computing nodes
                  and intricate network topologies, requiring automated network
                  deployment to reduce the time spent on configuration and
                  troubleshooting.
                </p>
              ))}
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="col-lg-4">
            <div className="position-sticky" style={{ top: "80px" }}>
              <h5 className="sidebar-title mb-3">Related Blogs</h5>
              <div className="related-links">
                <a href="#">
                  NX Unveils PicOS® 4.4.5: A Leap Forward in Network Performance
                  and Security
                </a>
                <a href="#">
                  Unlock Network Freedom: NX PicOS® Switches for Unified
                  Networking Experience
                </a>
                <a href="#">NX AmpCon: Your Network Automation Partner</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetails;
